import { Grid, Stack, IconButton, Box, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import cardData from "./CardData1";
import cardData2 from "./CardData2";
import { useNavigate } from "react-router-dom";
import CustomCard from "./CustomCard";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import CustomBlankCard from "./CustomBlankCard";
import CustomCard2 from "./CustomCard2";
import axios from "axios";
import grid from "./Icon/Grid103.webp";
import CustomCard3 from "./CustomCard3";
import ViewAllCard from "./ViewAllCard";
import MobileSlider from "./MobileSlider";
import BlogCard from "./CustomCard4";

const BlogcardSection = () => {
  const navigate = useNavigate();
  const scrollableRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showAll, setShowAll] = useState(false); // State for View All

  const handleReadMore = (card) => {
    navigate("/blog-page", { state: card });
  };

  const scrollLeft = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0
        ? showAll
          ? cardData2.length - 1 // 8 cards
          : 4 // 4 cards + ViewAllCard
        : prevIndex - 1
    );
  };

  const scrollRight = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex + 1 >= (showAll ? cardData2.length : 5) ? 0 : prevIndex + 1
    );
  };

  const handleViewAll = () => {
    setShowAll(true); // Show all 8 cards
    setCurrentIndex(0); // Reset to first card
  };

  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        paddingBottom: {
          xl: "60px",
          lg: "60px",
          md: "60px",
          sm: "60px",
          xs: "30px",
        },
        paddingTop: {
          xl: "60px",
          lg: "60px",
          md: "60px",
          sm: "60px",
          xs: "60px",
        },
        backgroundImage: `url(${grid})`,
        backgroundSize: "contain",
        backgroundPosition: "center",
      }}
    >
      <Stack
        sx={{
          width: {
            xl: "72%",
            lg: "80%",
            md: "90%",
            sm: "96%",
            xs: "93%",
          },
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Stack
          sx={{
            display: "flex",
            flexDirection: "column",
            paddingBottom: {
              xl: "60px",
              lg: "60px",
              md: "60px",
              sm: "60px",
              xs: "30px",
            },
          }}
        >
          <Stack sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Typography
              sx={{
                // border: " 1px solid red",
                fontSize: {
                  xs: "22px",
                  sm: "26px",
                  md: "30px",
                  lg: "34px",
                },
                color: "#054E91",
                 fontFamily: "'Roboto', sans-serif",
                fontWeight: 600,
                letterSpacing: "0.5px",
                textAlign: "left",
                display: "flex",
                flexDirection: "row",
                marginTop: { sm: "0", xs: "-36px" }
              }}
            >
              <Stack
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Stack
                  sx={{
                    width: { xl: "6px", lg: "6px", xs: "4px" },
                    height: { xs: "22px", sm: "36px", md: "30px" },
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    backgroundColor: "rgb(5 78 146)",
                    marginRight: "8px",
                    borderTopRightRadius: "8px",
                    borderBottomRightRadius: "8px",
                  }}
                >
                  <h4 style={{ color: "rgb(5 78 146)" }}>{""}</h4>
                </Stack>
              </Stack>
              <Stack>Our latest articles</Stack>
            </Typography>
            <Typography
              sx={{
                fontSize: {
                  xs: "15px",
                  sm: "17px",
                  md: "20px",
                },
                lineHeight: { xs: 1.5, sm: 1.80, md: 1.2 },
                 fontFamily: "'Roboto', sans-serif",
                color: "text.secondary",
                textAlign: "left",
                padding: 1,
                borderRadius: "8px",
                backgroundColor: "rgb(218 233 248)",
                marginTop: { sm: "0", xs: "8px" }
              }}
            >
              Discover helpful blogs from Vertex Suite. Learn about smart ways
              to use WhatsApp, automate tasks and improve communication- all
              shared in a simple, practical way to support your growth and
              everyday business needs.
            </Typography>
          </Stack>
        </Stack>

        {/* Desktop Cards */}

        <Grid
          container
          spacing={2}
          rowGap={2}
          sx={{
            // border: "1px solid red",
            display: { xs: "none", sm: "flex" },
            marginBottom: { xl: "20px", lg: "20px" },
          }}
        >
          {cardData.slice(0, 8).map((card, index) => (
            <Grid item key={index} xs={12} sm={6} md={3} lg={3} xl={3}>
              <BlogCard {...card} />
            </Grid>
          ))}
        </Grid>
        <MobileSlider cardData2={cardData2} />
      </Stack>
    </Stack>
  );
};

export default BlogcardSection;
